import { render, staticRenderFns } from "./BoardCategoryReg.vue?vue&type=template&id=2795abda&scoped=true"
import script from "./BoardCategoryReg.vue?vue&type=script&lang=js"
export * from "./BoardCategoryReg.vue?vue&type=script&lang=js"
import style0 from "./BoardCategoryReg.vue?vue&type=style&index=0&id=2795abda&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795abda",
  null
  
)

export default component.exports